import React from 'react';
import NotFound from './NotFound';
import Construction from './Construction';

const routes = {
  notFound: {
    path: '*',
    element: <NotFound />
  },
  construction: {
    path: '/construction',
    element: <Construction />
  }
};

export default routes; 